export default Object.freeze({
  CSHC: 'CSHC',
  HCC: 'HCC',
  PCC: 'PCC',
  VSPC: 'VSPC',
});
